import React, { useEffect } from "react";
import SignOnchat from "../../components/signon/signonchat.index";
import SignOnlogo from "../../components/signon/signon.index";
import Footerlogo from "../../components/signon/footerlogo.index";
import "./signon.style.css";
import { Layout } from "antd";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/msalAuth/AuthProvider";
import Loader from "../../components/configure/Loader";
import { isValidRedirectPath } from "../../components/configure/utils";
import GenesysChat from "../../components/livechat/livechat";

const { Content } = Layout;

const SignOn = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const storedPath = sessionStorage.getItem("sd_redirect");
    if (isAuthenticated) {
      if (storedPath && isValidRedirectPath(storedPath)) {
        navigate(storedPath, { replace: true });
      } else {
        navigate("/homepage", { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return <Loader message="Loading..." />;
  }

  return (
    <Layout className="sgn-sandee-layout">
      <Header />
      <div className="sgn-background-shapes">
        <div className="sgn-shape sgn-shape-1"></div>
        <div className="sgn-shape sgn-shape-2"></div>
        <div className="sgn-shape sgn-shape-3"></div>
      </div>

      <Content className="sgn-sandee-content">
        <div className="sgn-main-wrapper">
          <SignOnlogo />
          <SignOnchat />
        </div>
        <Footerlogo />
      </Content>
      <GenesysChat />
    </Layout>
  );
};

export default SignOn;
